module.exports = __webpack_public_path__ + "static/media/filterIconBlue.ec0df50b.svg";